export default function OnboardingProgress({ currentIndex, total, onGoToStep }) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: total }, (_, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onGoToStep(i)}
          aria-label={`Go to step ${i + 1}`}
          className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
            i === currentIndex
              ? "w-6 bg-primary"
              : i < currentIndex
                ? "w-2 bg-primary"
                : "w-2 bg-white/30"
          }`}
        />
      ))}
    </div>
  );
}
